import * as ambassadorWixEcomV1Order from './ecom-v1-order-orders.http.js';
import * as ambassadorWixEcomV1OrderTypes from './ecom-v1-order-orders.types.js';
import * as ambassadorWixEcomV1OrderUniversalTypes from './ecom-v1-order-orders.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function importOrder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.ImportOrderRequest,
  ambassadorWixEcomV1OrderTypes.ImportOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.ImportOrderResponse,
  ambassadorWixEcomV1OrderTypes.ImportOrderResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Order.importOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/import',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setOrderNumberCounter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.SetOrderNumberCounterRequest,
  ambassadorWixEcomV1OrderTypes.SetOrderNumberCounterRequest,
  ambassadorWixEcomV1OrderUniversalTypes.SetOrderNumberCounterResponse,
  ambassadorWixEcomV1OrderTypes.SetOrderNumberCounterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.setOrderNumberCounter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/import/set-order-number-counter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteImportedOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.BulkDeleteImportedOrdersRequest,
  ambassadorWixEcomV1OrderTypes.BulkDeleteImportedOrdersRequest,
  ambassadorWixEcomV1OrderUniversalTypes.BulkDeleteImportedOrdersResponse,
  ambassadorWixEcomV1OrderTypes.BulkDeleteImportedOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.bulkDeleteImportedOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/import/bulk-delete-imported-orders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function preparePaymentCollection(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.PreparePaymentCollectionRequest,
  ambassadorWixEcomV1OrderTypes.PreparePaymentCollectionRequest,
  ambassadorWixEcomV1OrderUniversalTypes.PreparePaymentCollectionResponse,
  ambassadorWixEcomV1OrderTypes.PreparePaymentCollectionResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.preparePaymentCollection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/prepare-payment-collection',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPaymentCollectabilityStatus(): __PublicMethodMetaInfo<
  'GET',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.GetPaymentCollectabilityStatusRequest,
  ambassadorWixEcomV1OrderTypes.GetPaymentCollectabilityStatusRequest,
  ambassadorWixEcomV1OrderUniversalTypes.GetPaymentCollectabilityStatusResponse,
  ambassadorWixEcomV1OrderTypes.GetPaymentCollectabilityStatusResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.getPaymentCollectabilityStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/payments-collector/orders/{ecomOrderId}/payment-collectability-status',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function recordManuallyCollectedPayment(): __PublicMethodMetaInfo<
  'POST',
  { orderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.RecordManuallyCollectedPaymentRequest,
  ambassadorWixEcomV1OrderTypes.RecordManuallyCollectedPaymentRequest,
  ambassadorWixEcomV1OrderUniversalTypes.RecordManuallyCollectedPaymentResponse,
  ambassadorWixEcomV1OrderTypes.RecordManuallyCollectedPaymentResponse
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.recordManuallyCollectedPayment(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{orderId}/manual-payment',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function paymentCollectionMarkOrderAsPaid(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.MarkOrderAsPaidRequest,
  ambassadorWixEcomV1OrderTypes.MarkOrderAsPaidRequest,
  ambassadorWixEcomV1OrderUniversalTypes.MarkOrderAsPaidResponse,
  ambassadorWixEcomV1OrderTypes.MarkOrderAsPaidResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.paymentCollectionMarkOrderAsPaid(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/mark-as-paid',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function paymentCollectionBulkMarkOrdersAsPaid(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.BulkMarkOrdersAsPaidRequest,
  ambassadorWixEcomV1OrderTypes.BulkMarkOrdersAsPaidRequest,
  ambassadorWixEcomV1OrderUniversalTypes.BulkMarkOrdersAsPaidResponse,
  ambassadorWixEcomV1OrderTypes.BulkMarkOrdersAsPaidResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.paymentCollectionBulkMarkOrdersAsPaid(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/payments-collector/mark-as-paid',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRefundabilityStatus(): __PublicMethodMetaInfo<
  'GET',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.GetRefundabilityStatusRequest,
  ambassadorWixEcomV1OrderTypes.GetRefundabilityStatusRequest,
  ambassadorWixEcomV1OrderUniversalTypes.GetRefundabilityStatusResponse,
  ambassadorWixEcomV1OrderTypes.GetRefundabilityStatusResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.getRefundabilityStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/payments-collector/orders/{ecomOrderId}/refundability',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function paymentCollectionCreatePaymentGatewayOrder(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.CreatePaymentGatewayOrderRequest,
  ambassadorWixEcomV1OrderTypes.CreatePaymentGatewayOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.CreatePaymentGatewayOrderResponse,
  ambassadorWixEcomV1OrderTypes.CreatePaymentGatewayOrderResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.paymentCollectionCreatePaymentGatewayOrder(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/create-payment-gateway-order',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function chargeMemberships(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.ChargeMembershipsRequest,
  ambassadorWixEcomV1OrderTypes.ChargeMembershipsRequest,
  ambassadorWixEcomV1OrderUniversalTypes.ChargeMembershipsResponse,
  ambassadorWixEcomV1OrderTypes.ChargeMembershipsResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.chargeMemberships(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/charge-membership',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function triggerRefund(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.TriggerRefundRequest,
  ambassadorWixEcomV1OrderTypes.TriggerRefundRequest,
  ambassadorWixEcomV1OrderUniversalTypes.TriggerRefundResponse,
  ambassadorWixEcomV1OrderTypes.TriggerRefundResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.triggerRefund(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/trigger-refund',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function voidAuthorizedPayments(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.VoidAuthorizedPaymentsRequest,
  ambassadorWixEcomV1OrderTypes.VoidAuthorizedPaymentsRequest,
  ambassadorWixEcomV1OrderUniversalTypes.VoidAuthorizedPaymentsResponse,
  ambassadorWixEcomV1OrderTypes.VoidAuthorizedPaymentsResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.voidAuthorizedPayments(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/void-authorized-payments',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function captureAuthorizedPayments(): __PublicMethodMetaInfo<
  'POST',
  { ecomOrderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.CaptureAuthorizedPaymentsRequest,
  ambassadorWixEcomV1OrderTypes.CaptureAuthorizedPaymentsRequest,
  ambassadorWixEcomV1OrderUniversalTypes.CaptureAuthorizedPaymentsResponse,
  ambassadorWixEcomV1OrderTypes.CaptureAuthorizedPaymentsResponse
> {
  const payload = { ecomOrderId: ':ecomOrderId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.captureAuthorizedPayments(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/payments-collector/orders/{ecomOrderId}/capture-authorized-payments',
    pathParams: { ecomOrderId: 'ecomOrderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOrder(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixEcomV1OrderUniversalTypes.GetOrderRequest,
  ambassadorWixEcomV1OrderTypes.GetOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.GetOrderResponse,
  ambassadorWixEcomV1OrderTypes.GetOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.getOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/orders/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.SearchOrdersRequest,
  ambassadorWixEcomV1OrderTypes.SearchOrdersRequest,
  ambassadorWixEcomV1OrderUniversalTypes.SearchOrdersResponse,
  ambassadorWixEcomV1OrderTypes.SearchOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Order.searchOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createOrder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.CreateOrderRequest,
  ambassadorWixEcomV1OrderTypes.CreateOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.CreateOrderResponse,
  ambassadorWixEcomV1OrderTypes.CreateOrderResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Order.createOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOrder(): __PublicMethodMetaInfo<
  'PATCH',
  { orderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderRequest,
  ambassadorWixEcomV1OrderTypes.UpdateOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderResponse,
  ambassadorWixEcomV1OrderTypes.UpdateOrderResponse
> {
  const payload = { order: { id: ':orderId' } } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.updateOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/orders/{order.id}',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrdersRequest,
  ambassadorWixEcomV1OrderTypes.BulkUpdateOrdersRequest,
  ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrdersResponse,
  ambassadorWixEcomV1OrderTypes.BulkUpdateOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Order.bulkUpdateOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/orders/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOrderLineItem(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string; lineItemId: string },
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderLineItemRequest,
  ambassadorWixEcomV1OrderTypes.UpdateOrderLineItemRequest,
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderLineItemResponse,
  ambassadorWixEcomV1OrderTypes.UpdateOrderLineItemResponse
> {
  const payload = { id: ':id', lineItem: { id: ':lineItemId' } } as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.updateOrderLineItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/orders/{id}/line-item/{lineItem.id}',
    pathParams: { id: 'id', lineItemId: 'lineItemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addActivity(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixEcomV1OrderUniversalTypes.AddActivityRequest,
  ambassadorWixEcomV1OrderTypes.AddActivityRequest,
  ambassadorWixEcomV1OrderUniversalTypes.AddActivityResponse,
  ambassadorWixEcomV1OrderTypes.AddActivityResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.addActivity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/{id}/activities',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addActivities(): __PublicMethodMetaInfo<
  'POST',
  { orderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.AddActivitiesRequest,
  ambassadorWixEcomV1OrderTypes.AddActivitiesRequest,
  ambassadorWixEcomV1OrderUniversalTypes.AddActivitiesResponse,
  ambassadorWixEcomV1OrderTypes.AddActivitiesResponse
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.addActivities(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/{orderId}/activities/add',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateActivity(): __PublicMethodMetaInfo<
  'PATCH',
  { id: string; activityId: string },
  ambassadorWixEcomV1OrderUniversalTypes.UpdateActivityRequest,
  ambassadorWixEcomV1OrderTypes.UpdateActivityRequest,
  ambassadorWixEcomV1OrderUniversalTypes.UpdateActivityResponse,
  ambassadorWixEcomV1OrderTypes.UpdateActivityResponse
> {
  const payload = { id: ':id', activityId: ':activityId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.updateActivity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/orders/{id}/activities/{activityId}',
    pathParams: { id: 'id', activityId: 'activityId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteActivity(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string; activityId: string },
  ambassadorWixEcomV1OrderUniversalTypes.DeleteActivityRequest,
  ambassadorWixEcomV1OrderTypes.DeleteActivityRequest,
  ambassadorWixEcomV1OrderUniversalTypes.DeleteActivityResponse,
  ambassadorWixEcomV1OrderTypes.DeleteActivityResponse
> {
  const payload = { id: ':id', activityId: ':activityId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.deleteActivity(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/orders/{id}/activities/{activityId}',
    pathParams: { id: 'id', activityId: 'activityId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelOrder(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixEcomV1OrderUniversalTypes.CancelOrderRequest,
  ambassadorWixEcomV1OrderTypes.CancelOrderRequest,
  ambassadorWixEcomV1OrderUniversalTypes.CancelOrderResponse,
  ambassadorWixEcomV1OrderTypes.CancelOrderResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.cancelOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/{id}/cancel',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOrderStatus(): __PublicMethodMetaInfo<
  'POST',
  { orderId: string },
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderStatusRequest,
  ambassadorWixEcomV1OrderTypes.UpdateOrderStatusRequest,
  ambassadorWixEcomV1OrderUniversalTypes.UpdateOrderStatusResponse,
  ambassadorWixEcomV1OrderTypes.UpdateOrderStatusResponse
> {
  const payload = { orderId: ':orderId' } as any;

  const getRequestOptions = ambassadorWixEcomV1Order.updateOrderStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/{orderId}/update-status',
    pathParams: { orderId: 'orderId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function aggregateOrders(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.AggregateOrdersRequest,
  ambassadorWixEcomV1OrderTypes.AggregateOrdersRequest,
  ambassadorWixEcomV1OrderUniversalTypes.AggregateOrdersResponse,
  ambassadorWixEcomV1OrderTypes.AggregateOrdersResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Order.aggregateOrders(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/orders/aggregate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateOrderTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrderTagsRequest,
  ambassadorWixEcomV1OrderTypes.BulkUpdateOrderTagsRequest,
  ambassadorWixEcomV1OrderUniversalTypes.BulkUpdateOrderTagsResponse,
  ambassadorWixEcomV1OrderTypes.BulkUpdateOrderTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1Order.bulkUpdateOrderTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/orders/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Order as OrderOriginal,
  OrderLineItem as OrderLineItemOriginal,
  ProductName as ProductNameOriginal,
  CatalogReference as CatalogReferenceOriginal,
  Price as PriceOriginal,
  DescriptionLine as DescriptionLineOriginal,
  DescriptionLineValueOneOf as DescriptionLineValueOneOfOriginal,
  DescriptionLineDescriptionLineValueOneOf as DescriptionLineDescriptionLineValueOneOfOriginal,
  DescriptionLineName as DescriptionLineNameOriginal,
  PlainTextValue as PlainTextValueOriginal,
  Color as ColorOriginal,
  DescriptionLineType as DescriptionLineTypeOriginal,
  DescriptionLineTypeWithLiterals as DescriptionLineTypeWithLiteralsOriginal,
  Image as ImageOriginal,
  FocalPoint as FocalPointOriginal,
  PhysicalProperties as PhysicalPropertiesOriginal,
  Dimensions as DimensionsOriginal,
  DimensionsUnit as DimensionsUnitOriginal,
  DimensionsUnitWithLiterals as DimensionsUnitWithLiteralsOriginal,
  ItemType as ItemTypeOriginal,
  ItemTypeItemTypeDataOneOf as ItemTypeItemTypeDataOneOfOriginal,
  ItemTypePreset as ItemTypePresetOriginal,
  ItemTypePresetWithLiterals as ItemTypePresetWithLiteralsOriginal,
  RestockLocation as RestockLocationOriginal,
  PaymentOptionType as PaymentOptionTypeOriginal,
  PaymentOptionTypeWithLiterals as PaymentOptionTypeWithLiteralsOriginal,
  ItemTaxFullDetails as ItemTaxFullDetailsOriginal,
  LineItemTaxInfo as LineItemTaxInfoOriginal,
  LineItemTaxBreakdown as LineItemTaxBreakdownOriginal,
  JurisdictionType as JurisdictionTypeOriginal,
  JurisdictionTypeWithLiterals as JurisdictionTypeWithLiteralsOriginal,
  DigitalFile as DigitalFileOriginal,
  SubscriptionInfo as SubscriptionInfoOriginal,
  SubscriptionTitle as SubscriptionTitleOriginal,
  SubscriptionDescription as SubscriptionDescriptionOriginal,
  SubscriptionSettings as SubscriptionSettingsOriginal,
  SubscriptionFrequency as SubscriptionFrequencyOriginal,
  SubscriptionFrequencyWithLiterals as SubscriptionFrequencyWithLiteralsOriginal,
  FreeTrialPeriod as FreeTrialPeriodOriginal,
  BillingSettings as BillingSettingsOriginal,
  BillingAdjustment as BillingAdjustmentOriginal,
  AdjustmentType as AdjustmentTypeOriginal,
  AdjustmentTypeWithLiterals as AdjustmentTypeWithLiteralsOriginal,
  BillingAdjustmentPriceSummary as BillingAdjustmentPriceSummaryOriginal,
  PriceDescription as PriceDescriptionOriginal,
  LocationAndQuantity as LocationAndQuantityOriginal,
  TaxableAddress as TaxableAddressOriginal,
  TaxableAddressTaxableAddressDataOneOf as TaxableAddressTaxableAddressDataOneOfOriginal,
  TaxableAddressType as TaxableAddressTypeOriginal,
  TaxableAddressTypeWithLiterals as TaxableAddressTypeWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ModifierGroup as ModifierGroupOriginal,
  TranslatableString as TranslatableStringOriginal,
  ItemModifier as ItemModifierOriginal,
  BuyerInfo as BuyerInfoOriginal,
  BuyerInfoIdOneOf as BuyerInfoIdOneOfOriginal,
  PaymentStatusEnumPaymentStatus as PaymentStatusEnumPaymentStatusOriginal,
  PaymentStatusEnumPaymentStatusWithLiterals as PaymentStatusEnumPaymentStatusWithLiteralsOriginal,
  FulfillmentStatus as FulfillmentStatusOriginal,
  FulfillmentStatusWithLiterals as FulfillmentStatusWithLiteralsOriginal,
  WeightUnit as WeightUnitOriginal,
  WeightUnitWithLiterals as WeightUnitWithLiteralsOriginal,
  CurrencyConversionDetails as CurrencyConversionDetailsOriginal,
  PriceSummary as PriceSummaryOriginal,
  AddressWithContact as AddressWithContactOriginal,
  Address as AddressOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  FullAddressContactDetails as FullAddressContactDetailsOriginal,
  VatId as VatIdOriginal,
  VatType as VatTypeOriginal,
  VatTypeWithLiterals as VatTypeWithLiteralsOriginal,
  V1ShippingInformation as V1ShippingInformationOriginal,
  DeliveryLogistics as DeliveryLogisticsOriginal,
  DeliveryLogisticsAddressOneOf as DeliveryLogisticsAddressOneOfOriginal,
  PickupDetails as PickupDetailsOriginal,
  PickupAddress as PickupAddressOriginal,
  PickupMethod as PickupMethodOriginal,
  PickupMethodWithLiterals as PickupMethodWithLiteralsOriginal,
  DeliveryTimeSlot as DeliveryTimeSlotOriginal,
  ShippingPrice as ShippingPriceOriginal,
  ShippingRegion as ShippingRegionOriginal,
  OrderStatus as OrderStatusOriginal,
  OrderStatusWithLiterals as OrderStatusWithLiteralsOriginal,
  TaxSummary as TaxSummaryOriginal,
  OrderTaxInfo as OrderTaxInfoOriginal,
  OrderTaxBreakdown as OrderTaxBreakdownOriginal,
  AppliedDiscount as AppliedDiscountOriginal,
  AppliedDiscountDiscountSourceOneOf as AppliedDiscountDiscountSourceOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  Coupon as CouponOriginal,
  MerchantDiscount as MerchantDiscountOriginal,
  MerchantDiscountMerchantDiscountReasonOneOf as MerchantDiscountMerchantDiscountReasonOneOfOriginal,
  DiscountReason as DiscountReasonOriginal,
  DiscountReasonWithLiterals as DiscountReasonWithLiteralsOriginal,
  DiscountRule as DiscountRuleOriginal,
  DiscountRuleName as DiscountRuleNameOriginal,
  LineItemDiscount as LineItemDiscountOriginal,
  ItemCombination as ItemCombinationOriginal,
  ItemCombinationLineItem as ItemCombinationLineItemOriginal,
  Activity as ActivityOriginal,
  ActivityContentOneOf as ActivityContentOneOfOriginal,
  CustomActivity as CustomActivityOriginal,
  MerchantComment as MerchantCommentOriginal,
  OrderRefunded as OrderRefundedOriginal,
  OrderCreatedFromExchange as OrderCreatedFromExchangeOriginal,
  NewExchangeOrderCreated as NewExchangeOrderCreatedOriginal,
  LineItemExchangeData as LineItemExchangeDataOriginal,
  DraftOrderChangesApplied as DraftOrderChangesAppliedOriginal,
  OrderChange as OrderChangeOriginal,
  OrderChangeValueOneOf as OrderChangeValueOneOfOriginal,
  LineItemChanges as LineItemChangesOriginal,
  LineItemQuantityChange as LineItemQuantityChangeOriginal,
  LineItemQuantityChangeType as LineItemQuantityChangeTypeOriginal,
  LineItemQuantityChangeTypeWithLiterals as LineItemQuantityChangeTypeWithLiteralsOriginal,
  LineItemPriceChange as LineItemPriceChangeOriginal,
  LineItemProductNameChange as LineItemProductNameChangeOriginal,
  LineItemDescriptionLineChange as LineItemDescriptionLineChangeOriginal,
  LineItemModifiersChange as LineItemModifiersChangeOriginal,
  ManagedLineItem as ManagedLineItemOriginal,
  ManagedDiscount as ManagedDiscountOriginal,
  TranslatedValue as TranslatedValueOriginal,
  LineItemAmount as LineItemAmountOriginal,
  ManagedAdditionalFee as ManagedAdditionalFeeOriginal,
  TotalPriceChange as TotalPriceChangeOriginal,
  ShippingInformationChange as ShippingInformationChangeOriginal,
  ShippingInformation as ShippingInformationOriginal,
  SavedPaymentMethod as SavedPaymentMethodOriginal,
  AuthorizedPaymentCreated as AuthorizedPaymentCreatedOriginal,
  AuthorizedPaymentCaptured as AuthorizedPaymentCapturedOriginal,
  AuthorizedPaymentVoided as AuthorizedPaymentVoidedOriginal,
  RefundInitiated as RefundInitiatedOriginal,
  RefundedPayment as RefundedPaymentOriginal,
  RefundedPaymentKindOneOf as RefundedPaymentKindOneOfOriginal,
  RegularPaymentRefund as RegularPaymentRefundOriginal,
  GiftCardPaymentRefund as GiftCardPaymentRefundOriginal,
  MembershipPaymentRefund as MembershipPaymentRefundOriginal,
  PaymentRefunded as PaymentRefundedOriginal,
  PaymentRefundFailed as PaymentRefundFailedOriginal,
  RefundedAsStoreCredit as RefundedAsStoreCreditOriginal,
  PaymentPending as PaymentPendingOriginal,
  PaymentPendingPaymentDetailsOneOf as PaymentPendingPaymentDetailsOneOfOriginal,
  RegularPayment as RegularPaymentOriginal,
  RegularPaymentPaymentMethodDetailsOneOf as RegularPaymentPaymentMethodDetailsOneOfOriginal,
  CreditCardDetails as CreditCardDetailsOriginal,
  PaymentCanceled as PaymentCanceledOriginal,
  PaymentCanceledPaymentDetailsOneOf as PaymentCanceledPaymentDetailsOneOfOriginal,
  PaymentDeclined as PaymentDeclinedOriginal,
  PaymentDeclinedPaymentDetailsOneOf as PaymentDeclinedPaymentDetailsOneOfOriginal,
  ReceiptCreated as ReceiptCreatedOriginal,
  ReceiptCreatedReceiptInfoOneOf as ReceiptCreatedReceiptInfoOneOfOriginal,
  WixReceipt as WixReceiptOriginal,
  ExternalReceipt as ExternalReceiptOriginal,
  ReceiptSent as ReceiptSentOriginal,
  ReceiptSentReceiptInfoOneOf as ReceiptSentReceiptInfoOneOfOriginal,
  ChargebackCreated as ChargebackCreatedOriginal,
  ChargebackReversed as ChargebackReversedOriginal,
  ActivityType as ActivityTypeOriginal,
  ActivityTypeWithLiterals as ActivityTypeWithLiteralsOriginal,
  OrderActivityTypeEnumActivityType as OrderActivityTypeEnumActivityTypeOriginal,
  OrderActivityTypeEnumActivityTypeWithLiterals as OrderActivityTypeEnumActivityTypeWithLiteralsOriginal,
  AttributionSource as AttributionSourceOriginal,
  AttributionSourceWithLiterals as AttributionSourceWithLiteralsOriginal,
  CreatedBy as CreatedByOriginal,
  CreatedByStringOneOf as CreatedByStringOneOfOriginal,
  ChannelInfo as ChannelInfoOriginal,
  ChannelType as ChannelTypeOriginal,
  ChannelTypeWithLiterals as ChannelTypeWithLiteralsOriginal,
  CustomField as CustomFieldOriginal,
  BalanceSummary as BalanceSummaryOriginal,
  Balance as BalanceOriginal,
  CashRounding as CashRoundingOriginal,
  AdditionalFee as AdditionalFeeOriginal,
  AdditionalFeeSource as AdditionalFeeSourceOriginal,
  AdditionalFeeSourceWithLiterals as AdditionalFeeSourceWithLiteralsOriginal,
  FulfillmentStatusesAggregate as FulfillmentStatusesAggregateOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  Location as LocationOriginal,
  OrderSettings as OrderSettingsOriginal,
  OrderSettingsAllowedActionsOneOf as OrderSettingsAllowedActionsOneOfOriginal,
  OrderSettingsEditableByOneOf as OrderSettingsEditableByOneOfOriginal,
  CustomAllowedActions as CustomAllowedActionsOriginal,
  OrderActionType as OrderActionTypeOriginal,
  OrderActionTypeWithLiterals as OrderActionTypeWithLiteralsOriginal,
  OwnerApps as OwnerAppsOriginal,
  SpecificItemsCouponBehavior as SpecificItemsCouponBehaviorOriginal,
  SpecificItemsCouponBehaviorWithLiterals as SpecificItemsCouponBehaviorWithLiteralsOriginal,
  FormInfo as FormInfoOriginal,
  FormIdentifier as FormIdentifierOriginal,
  PlatformFeeSummary as PlatformFeeSummaryOriginal,
  PlatformFee as PlatformFeeOriginal,
  ChargeType as ChargeTypeOriginal,
  ChargeTypeWithLiterals as ChargeTypeWithLiteralsOriginal,
  OrderApproved as OrderApprovedOriginal,
  OrdersExperiments as OrdersExperimentsOriginal,
  OrderRejectedEventOrderRejected as OrderRejectedEventOrderRejectedOriginal,
  OrderItemsRestocked as OrderItemsRestockedOriginal,
  V1RestockItem as V1RestockItemOriginal,
  OrderImported as OrderImportedOriginal,
  ImportedOrderDeleted as ImportedOrderDeletedOriginal,
  PaymentStatusUpdated as PaymentStatusUpdatedOriginal,
  FulfillmentStatusUpdated as FulfillmentStatusUpdatedOriginal,
  OrderCanceledEventOrderCanceled as OrderCanceledEventOrderCanceledOriginal,
  OrderDeltasCommitted as OrderDeltasCommittedOriginal,
  CommittedDiffs as CommittedDiffsOriginal,
  CommittedDiffsShippingUpdateInfoOneOf as CommittedDiffsShippingUpdateInfoOneOfOriginal,
  ItemChangedDetails as ItemChangedDetailsOriginal,
  OrderLineItemChangedDetails as OrderLineItemChangedDetailsOriginal,
  DeltaPaymentOptionType as DeltaPaymentOptionTypeOriginal,
  DeltaPaymentOptionTypeWithLiterals as DeltaPaymentOptionTypeWithLiteralsOriginal,
  LineItemDelta as LineItemDeltaOriginal,
  LineItemDeltaDeltaOneOf as LineItemDeltaDeltaOneOfOriginal,
  AppliedDiscountDelta as AppliedDiscountDeltaOriginal,
  AppliedDiscountDeltaDeltaOneOf as AppliedDiscountDeltaDeltaOneOfOriginal,
  AdditionalFeeDelta as AdditionalFeeDeltaOriginal,
  AdditionalFeeDeltaDeltaOneOf as AdditionalFeeDeltaDeltaOneOfOriginal,
  DraftOrderCommitSettings as DraftOrderCommitSettingsOriginal,
  InventoryUpdateDetails as InventoryUpdateDetailsOriginal,
  InventoryAction as InventoryActionOriginal,
  InventoryActionWithLiterals as InventoryActionWithLiteralsOriginal,
  ImportOrderRequest as ImportOrderRequestOriginal,
  ImportOrderResponse as ImportOrderResponseOriginal,
  SetOrderNumberCounterRequest as SetOrderNumberCounterRequestOriginal,
  SetOrderNumberCounterResponse as SetOrderNumberCounterResponseOriginal,
  BulkDeleteImportedOrdersRequest as BulkDeleteImportedOrdersRequestOriginal,
  BulkDeleteImportedOrdersResponse as BulkDeleteImportedOrdersResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdateInternalDocumentsEvent as UpdateInternalDocumentsEventOriginal,
  UpdateInternalDocumentsEventOperationOneOf as UpdateInternalDocumentsEventOperationOneOfOriginal,
  InternalDocument as InternalDocumentOriginal,
  InternalDocumentUpdateOperation as InternalDocumentUpdateOperationOriginal,
  DeleteByIdsOperation as DeleteByIdsOperationOriginal,
  DeleteByFilterOperation as DeleteByFilterOperationOriginal,
  InternalDocumentUpdateByFilterOperation as InternalDocumentUpdateByFilterOperationOriginal,
  InternalUpdateExistingOperation as InternalUpdateExistingOperationOriginal,
  VersionedDocumentUpdateOperation as VersionedDocumentUpdateOperationOriginal,
  VersioningMode as VersioningModeOriginal,
  VersioningModeWithLiterals as VersioningModeWithLiteralsOriginal,
  VersionedDeleteByIdsOperation as VersionedDeleteByIdsOperationOriginal,
  VersionedDocumentId as VersionedDocumentIdOriginal,
  TriggerReindexRequest as TriggerReindexRequestOriginal,
  TriggerReindexResponse as TriggerReindexResponseOriginal,
  Empty as EmptyOriginal,
  TriggerReindexOrderRequest as TriggerReindexOrderRequestOriginal,
  SendBuyerConfirmationEmailRequest as SendBuyerConfirmationEmailRequestOriginal,
  SendBuyerConfirmationEmailResponse as SendBuyerConfirmationEmailResponseOriginal,
  SendBuyerPaymentsReceivedEmailRequest as SendBuyerPaymentsReceivedEmailRequestOriginal,
  SendBuyerPaymentsReceivedEmailResponse as SendBuyerPaymentsReceivedEmailResponseOriginal,
  SendBuyerPickupConfirmationEmailRequest as SendBuyerPickupConfirmationEmailRequestOriginal,
  SendBuyerPickupConfirmationEmailResponse as SendBuyerPickupConfirmationEmailResponseOriginal,
  BulkSendBuyerPickupConfirmationEmailsRequest as BulkSendBuyerPickupConfirmationEmailsRequestOriginal,
  BulkSendBuyerPickupConfirmationEmailsResponse as BulkSendBuyerPickupConfirmationEmailsResponseOriginal,
  SendBuyerShippingConfirmationEmailRequest as SendBuyerShippingConfirmationEmailRequestOriginal,
  SendBuyerShippingConfirmationEmailResponse as SendBuyerShippingConfirmationEmailResponseOriginal,
  BulkSendBuyerShippingConfirmationEmailsRequest as BulkSendBuyerShippingConfirmationEmailsRequestOriginal,
  BulkSendBuyerShippingConfirmationEmailsResponse as BulkSendBuyerShippingConfirmationEmailsResponseOriginal,
  SendMerchantOrderReceivedNotificationRequest as SendMerchantOrderReceivedNotificationRequestOriginal,
  SendMerchantOrderReceivedNotificationResponse as SendMerchantOrderReceivedNotificationResponseOriginal,
  SendCancelRefundEmailRequest as SendCancelRefundEmailRequestOriginal,
  SendCancelRefundEmailResponse as SendCancelRefundEmailResponseOriginal,
  SendRefundEmailRequest as SendRefundEmailRequestOriginal,
  SendRefundEmailResponse as SendRefundEmailResponseOriginal,
  SendFulfillmentEmailRequest as SendFulfillmentEmailRequestOriginal,
  SendFulfillmentEmailResponse as SendFulfillmentEmailResponseOriginal,
  SendMerchantOrderReceivedPushRequest as SendMerchantOrderReceivedPushRequestOriginal,
  SendMerchantOrderReceivedPushResponse as SendMerchantOrderReceivedPushResponseOriginal,
  PreviewEmailByTypeRequest as PreviewEmailByTypeRequestOriginal,
  PreviewEmailType as PreviewEmailTypeOriginal,
  PreviewEmailTypeWithLiterals as PreviewEmailTypeWithLiteralsOriginal,
  PreviewEmailByTypeResponse as PreviewEmailByTypeResponseOriginal,
  PreviewRefundEmailRequest as PreviewRefundEmailRequestOriginal,
  RefundDetails as RefundDetailsOriginal,
  RefundItem as RefundItemOriginal,
  LineItemRefund as LineItemRefundOriginal,
  AdditionalFeeRefund as AdditionalFeeRefundOriginal,
  ShippingRefund as ShippingRefundOriginal,
  PreviewRefundEmailResponse as PreviewRefundEmailResponseOriginal,
  PreviewCancelEmailRequest as PreviewCancelEmailRequestOriginal,
  PreviewCancelEmailResponse as PreviewCancelEmailResponseOriginal,
  PreviewCancelRefundEmailRequest as PreviewCancelRefundEmailRequestOriginal,
  PreviewCancelRefundEmailResponse as PreviewCancelRefundEmailResponseOriginal,
  PreviewBuyerPaymentsReceivedEmailRequest as PreviewBuyerPaymentsReceivedEmailRequestOriginal,
  PreviewBuyerPaymentsReceivedEmailResponse as PreviewBuyerPaymentsReceivedEmailResponseOriginal,
  PreviewBuyerConfirmationEmailRequest as PreviewBuyerConfirmationEmailRequestOriginal,
  PreviewBuyerConfirmationEmailResponse as PreviewBuyerConfirmationEmailResponseOriginal,
  PreviewBuyerPickupConfirmationEmailRequest as PreviewBuyerPickupConfirmationEmailRequestOriginal,
  PreviewBuyerPickupConfirmationEmailResponse as PreviewBuyerPickupConfirmationEmailResponseOriginal,
  PreviewShippingConfirmationEmailRequest as PreviewShippingConfirmationEmailRequestOriginal,
  PreviewShippingConfirmationEmailResponse as PreviewShippingConfirmationEmailResponseOriginal,
  PreviewResendDownloadLinksEmailRequest as PreviewResendDownloadLinksEmailRequestOriginal,
  PreviewResendDownloadLinksEmailResponse as PreviewResendDownloadLinksEmailResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  HasCustomEmailConfigurationsRequest as HasCustomEmailConfigurationsRequestOriginal,
  HasCustomEmailConfigurationsResponse as HasCustomEmailConfigurationsResponseOriginal,
  AddToAutomationMigrationPopulationRequest as AddToAutomationMigrationPopulationRequestOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  AddToAutomationMigrationPopulationResponse as AddToAutomationMigrationPopulationResponseOriginal,
  IsInAutomationMigrationPopulationRequest as IsInAutomationMigrationPopulationRequestOriginal,
  IsInAutomationMigrationPopulationResponse as IsInAutomationMigrationPopulationResponseOriginal,
  PreparePaymentCollectionRequest as PreparePaymentCollectionRequestOriginal,
  RedirectUrls as RedirectUrlsOriginal,
  DelayedCaptureSettings as DelayedCaptureSettingsOriginal,
  ScheduledAction as ScheduledActionOriginal,
  ScheduledActionWithLiterals as ScheduledActionWithLiteralsOriginal,
  Duration as DurationOriginal,
  DurationUnit as DurationUnitOriginal,
  DurationUnitWithLiterals as DurationUnitWithLiteralsOriginal,
  PreparePaymentCollectionResponse as PreparePaymentCollectionResponseOriginal,
  GetPaymentCollectabilityStatusRequest as GetPaymentCollectabilityStatusRequestOriginal,
  GetPaymentCollectabilityStatusResponse as GetPaymentCollectabilityStatusResponseOriginal,
  PaymentCollectabilityStatus as PaymentCollectabilityStatusOriginal,
  PaymentCollectabilityStatusWithLiterals as PaymentCollectabilityStatusWithLiteralsOriginal,
  RecordManuallyCollectedPaymentRequest as RecordManuallyCollectedPaymentRequestOriginal,
  UserDefinedPaymentMethodName as UserDefinedPaymentMethodNameOriginal,
  UserDefinedPaymentMethodNameKindOneOf as UserDefinedPaymentMethodNameKindOneOfOriginal,
  PredefinedPaymentMethod as PredefinedPaymentMethodOriginal,
  PredefinedPaymentMethodWithLiterals as PredefinedPaymentMethodWithLiteralsOriginal,
  RecordManuallyCollectedPaymentResponse as RecordManuallyCollectedPaymentResponseOriginal,
  MarkOrderAsPaidRequest as MarkOrderAsPaidRequestOriginal,
  MarkOrderAsPaidResponse as MarkOrderAsPaidResponseOriginal,
  BulkMarkOrdersAsPaidRequest as BulkMarkOrdersAsPaidRequestOriginal,
  BulkMarkOrdersAsPaidResponse as BulkMarkOrdersAsPaidResponseOriginal,
  BulkOrderResult as BulkOrderResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetRefundabilityStatusRequest as GetRefundabilityStatusRequestOriginal,
  GetRefundabilityStatusResponse as GetRefundabilityStatusResponseOriginal,
  Refundability as RefundabilityOriginal,
  RefundabilityAdditionalRefundabilityInfoOneOf as RefundabilityAdditionalRefundabilityInfoOneOfOriginal,
  RefundableStatus as RefundableStatusOriginal,
  RefundableStatusWithLiterals as RefundableStatusWithLiteralsOriginal,
  NonRefundableReason as NonRefundableReasonOriginal,
  NonRefundableReasonWithLiterals as NonRefundableReasonWithLiteralsOriginal,
  ManuallyRefundableReason as ManuallyRefundableReasonOriginal,
  ManuallyRefundableReasonWithLiterals as ManuallyRefundableReasonWithLiteralsOriginal,
  CreatePaymentGatewayOrderRequest as CreatePaymentGatewayOrderRequestOriginal,
  ChargedBy as ChargedByOriginal,
  CreatePaymentGatewayOrderResponse as CreatePaymentGatewayOrderResponseOriginal,
  ChargeMembershipsRequest as ChargeMembershipsRequestOriginal,
  MembershipChargeItem as MembershipChargeItemOriginal,
  MembershipName as MembershipNameOriginal,
  ServiceProperties as ServicePropertiesOriginal,
  ChargeMembershipsResponse as ChargeMembershipsResponseOriginal,
  TriggerRefundRequest as TriggerRefundRequestOriginal,
  PaymentRefund as PaymentRefundOriginal,
  RefundSideEffects as RefundSideEffectsOriginal,
  RestockInfo as RestockInfoOriginal,
  RestockType as RestockTypeOriginal,
  RestockTypeWithLiterals as RestockTypeWithLiteralsOriginal,
  RestockItem as RestockItemOriginal,
  TriggerRefundResponse as TriggerRefundResponseOriginal,
  OrderTransactions as OrderTransactionsOriginal,
  Payment as PaymentOriginal,
  PaymentPaymentDetailsOneOf as PaymentPaymentDetailsOneOfOriginal,
  PaymentReceiptInfoOneOf as PaymentReceiptInfoOneOfOriginal,
  RegularPaymentDetails as RegularPaymentDetailsOriginal,
  RegularPaymentDetailsPaymentMethodDetailsOneOf as RegularPaymentDetailsPaymentMethodDetailsOneOfOriginal,
  TransactionStatus as TransactionStatusOriginal,
  TransactionStatusWithLiterals as TransactionStatusWithLiteralsOriginal,
  CreditCardPaymentMethodDetails as CreditCardPaymentMethodDetailsOriginal,
  AuthorizationDetails as AuthorizationDetailsOriginal,
  AuthorizationCapture as AuthorizationCaptureOriginal,
  AuthorizationCaptureStatus as AuthorizationCaptureStatusOriginal,
  AuthorizationCaptureStatusWithLiterals as AuthorizationCaptureStatusWithLiteralsOriginal,
  AuthorizationActionFailureDetails as AuthorizationActionFailureDetailsOriginal,
  AuthorizationVoid as AuthorizationVoidOriginal,
  AuthorizationVoidStatus as AuthorizationVoidStatusOriginal,
  AuthorizationVoidStatusWithLiterals as AuthorizationVoidStatusWithLiteralsOriginal,
  Reason as ReasonOriginal,
  ReasonWithLiterals as ReasonWithLiteralsOriginal,
  V1ScheduledAction as V1ScheduledActionOriginal,
  ActionType as ActionTypeOriginal,
  ActionTypeWithLiterals as ActionTypeWithLiteralsOriginal,
  Chargeback as ChargebackOriginal,
  ChargebackStatus as ChargebackStatusOriginal,
  ChargebackStatusWithLiterals as ChargebackStatusWithLiteralsOriginal,
  PaymentMethodName as PaymentMethodNameOriginal,
  GiftCardPaymentDetails as GiftCardPaymentDetailsOriginal,
  MembershipPaymentDetails as MembershipPaymentDetailsOriginal,
  MembershipPaymentStatus as MembershipPaymentStatusOriginal,
  MembershipPaymentStatusWithLiterals as MembershipPaymentStatusWithLiteralsOriginal,
  WixReceiptInfo as WixReceiptInfoOriginal,
  ExternalReceiptInfo as ExternalReceiptInfoOriginal,
  CashRoundingDetails as CashRoundingDetailsOriginal,
  PaymentStatus as PaymentStatusOriginal,
  PaymentStatusWithLiterals as PaymentStatusWithLiteralsOriginal,
  Refund as RefundOriginal,
  RefundTransaction as RefundTransactionOriginal,
  RefundStatus as RefundStatusOriginal,
  RefundStatusWithLiterals as RefundStatusWithLiteralsOriginal,
  RefundStatusInfo as RefundStatusInfoOriginal,
  AggregatedRefundSummary as AggregatedRefundSummaryOriginal,
  RefundItemsBreakdown as RefundItemsBreakdownOriginal,
  LineItemRefundSummary as LineItemRefundSummaryOriginal,
  CalculateRefundRequest as CalculateRefundRequestOriginal,
  CalculateRefundItemRequest as CalculateRefundItemRequestOriginal,
  CalculateRefundResponse as CalculateRefundResponseOriginal,
  CalculateRefundItemResponse as CalculateRefundItemResponseOriginal,
  VoidAuthorizedPaymentsRequest as VoidAuthorizedPaymentsRequestOriginal,
  VoidAuthorizedPaymentsResponse as VoidAuthorizedPaymentsResponseOriginal,
  CaptureAuthorizedPaymentsRequest as CaptureAuthorizedPaymentsRequestOriginal,
  PaymentCapture as PaymentCaptureOriginal,
  CaptureAuthorizedPaymentsResponse as CaptureAuthorizedPaymentsResponseOriginal,
  ChargeSavedPaymentMethodRequest as ChargeSavedPaymentMethodRequestOriginal,
  ChargeSavedPaymentMethodResponse as ChargeSavedPaymentMethodResponseOriginal,
  DiffmatokyPayload as DiffmatokyPayloadOriginal,
  ErrorInformation as ErrorInformationOriginal,
  GetOrderRequest as GetOrderRequestOriginal,
  GetOrderResponse as GetOrderResponseOriginal,
  InternalQueryOrdersRequest as InternalQueryOrdersRequestOriginal,
  PlatformQuery as PlatformQueryOriginal,
  PlatformQueryPagingMethodOneOf as PlatformQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  PlatformPaging as PlatformPagingOriginal,
  CursorPaging as CursorPagingOriginal,
  InternalQueryOrdersResponse as InternalQueryOrdersResponseOriginal,
  PlatformPagingMetadata as PlatformPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  QueryOrderRequest as QueryOrderRequestOriginal,
  QueryOrderResponse as QueryOrderResponseOriginal,
  SearchOrdersRequest as SearchOrdersRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  SearchOrdersResponse as SearchOrdersResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  CreateOrderRequest as CreateOrderRequestOriginal,
  OrderCreationSettings as OrderCreationSettingsOriginal,
  OrderCreationSettingsEditableByOneOf as OrderCreationSettingsEditableByOneOfOriginal,
  OrderApprovalStrategy as OrderApprovalStrategyOriginal,
  OrderApprovalStrategyWithLiterals as OrderApprovalStrategyWithLiteralsOriginal,
  OrderCreateNotifications as OrderCreateNotificationsOriginal,
  CreateOrderResponse as CreateOrderResponseOriginal,
  UpdateOrderRequest as UpdateOrderRequestOriginal,
  UpdateOrderResponse as UpdateOrderResponseOriginal,
  BulkUpdateOrdersRequest as BulkUpdateOrdersRequestOriginal,
  MaskedOrder as MaskedOrderOriginal,
  BulkUpdateOrdersResponse as BulkUpdateOrdersResponseOriginal,
  CommitDeltasRequest as CommitDeltasRequestOriginal,
  DraftOrderDiffs as DraftOrderDiffsOriginal,
  DraftOrderDiffsShippingUpdateInfoOneOf as DraftOrderDiffsShippingUpdateInfoOneOfOriginal,
  DraftOrderDiffsBuyerUpdateInfoOneOf as DraftOrderDiffsBuyerUpdateInfoOneOfOriginal,
  DraftOrderDiffsBillingUpdateInfoOneOf as DraftOrderDiffsBillingUpdateInfoOneOfOriginal,
  DraftOrderDiffsRecipientUpdateInfoOneOf as DraftOrderDiffsRecipientUpdateInfoOneOfOriginal,
  V1LineItemDelta as V1LineItemDeltaOriginal,
  V1LineItemDeltaDeltaOneOf as V1LineItemDeltaDeltaOneOfOriginal,
  CommitDeltasResponse as CommitDeltasResponseOriginal,
  ArchiveOrderRequest as ArchiveOrderRequestOriginal,
  ArchiveOrderResponse as ArchiveOrderResponseOriginal,
  BulkArchiveOrdersRequest as BulkArchiveOrdersRequestOriginal,
  BulkArchiveOrdersResponse as BulkArchiveOrdersResponseOriginal,
  BulkArchiveOrdersByFilterRequest as BulkArchiveOrdersByFilterRequestOriginal,
  BulkArchiveOrdersByFilterResponse as BulkArchiveOrdersByFilterResponseOriginal,
  UnArchiveOrderRequest as UnArchiveOrderRequestOriginal,
  UnArchiveOrderResponse as UnArchiveOrderResponseOriginal,
  BulkUnArchiveOrdersRequest as BulkUnArchiveOrdersRequestOriginal,
  BulkUnArchiveOrdersResponse as BulkUnArchiveOrdersResponseOriginal,
  BulkUnArchiveOrdersByFilterRequest as BulkUnArchiveOrdersByFilterRequestOriginal,
  BulkUnArchiveOrdersByFilterResponse as BulkUnArchiveOrdersByFilterResponseOriginal,
  UpdateBuyerInfoRequest as UpdateBuyerInfoRequestOriginal,
  BuyerInfoUpdate as BuyerInfoUpdateOriginal,
  UpdateBuyerInfoResponse as UpdateBuyerInfoResponseOriginal,
  UpdateBuyerEmailRequest as UpdateBuyerEmailRequestOriginal,
  UpdateBuyerEmailResponse as UpdateBuyerEmailResponseOriginal,
  UpdateOrderShippingAddressRequest as UpdateOrderShippingAddressRequestOriginal,
  UpdateOrderShippingAddressResponse as UpdateOrderShippingAddressResponseOriginal,
  UpdateBillingContactDetailsRequest as UpdateBillingContactDetailsRequestOriginal,
  UpdateBillingContactDetailsResponse as UpdateBillingContactDetailsResponseOriginal,
  UpdateOrderLineItemRequest as UpdateOrderLineItemRequestOriginal,
  UpdateOrderLineItemResponse as UpdateOrderLineItemResponseOriginal,
  UpdateOrderLineItemsRequest as UpdateOrderLineItemsRequestOriginal,
  MaskedOrderLineItem as MaskedOrderLineItemOriginal,
  UpdateOrderLineItemsResponse as UpdateOrderLineItemsResponseOriginal,
  AddInternalActivityRequest as AddInternalActivityRequestOriginal,
  InternalActivity as InternalActivityOriginal,
  InternalActivityContentOneOf as InternalActivityContentOneOfOriginal,
  OrderPlaced as OrderPlacedOriginal,
  OrderPaid as OrderPaidOriginal,
  OrderFulfilled as OrderFulfilledOriginal,
  OrderNotFulfilled as OrderNotFulfilledOriginal,
  OrderCanceled as OrderCanceledOriginal,
  DownloadLinkSent as DownloadLinkSentOriginal,
  TrackingNumberAdded as TrackingNumberAddedOriginal,
  TrackingNumberEdited as TrackingNumberEditedOriginal,
  TrackingLinkAdded as TrackingLinkAddedOriginal,
  ShippingConfirmationEmailSent as ShippingConfirmationEmailSentOriginal,
  InvoiceAdded as InvoiceAddedOriginal,
  InvoiceSent as InvoiceSentOriginal,
  FulfillerEmailSent as FulfillerEmailSentOriginal,
  ShippingAddressEdited as ShippingAddressEditedOriginal,
  EmailEdited as EmailEditedOriginal,
  PickupReadyEmailSent as PickupReadyEmailSentOriginal,
  OrderPartiallyPaid as OrderPartiallyPaidOriginal,
  OrderPending as OrderPendingOriginal,
  OrderRejected as OrderRejectedOriginal,
  AddInternalActivityResponse as AddInternalActivityResponseOriginal,
  AddActivityRequest as AddActivityRequestOriginal,
  PublicActivity as PublicActivityOriginal,
  PublicActivityContentOneOf as PublicActivityContentOneOfOriginal,
  AddActivityResponse as AddActivityResponseOriginal,
  AddActivitiesRequest as AddActivitiesRequestOriginal,
  AddActivitiesResponse as AddActivitiesResponseOriginal,
  UpdateActivityRequest as UpdateActivityRequestOriginal,
  UpdateActivityResponse as UpdateActivityResponseOriginal,
  DeleteActivityRequest as DeleteActivityRequestOriginal,
  DeleteActivityResponse as DeleteActivityResponseOriginal,
  UpdateLineItemsDescriptionLinesRequest as UpdateLineItemsDescriptionLinesRequestOriginal,
  LineItemUpdate as LineItemUpdateOriginal,
  UpdateLineItemsDescriptionLinesResponse as UpdateLineItemsDescriptionLinesResponseOriginal,
  MarkOrderAsSeenByHumanRequest as MarkOrderAsSeenByHumanRequestOriginal,
  MarkOrderAsSeenByHumanResponse as MarkOrderAsSeenByHumanResponseOriginal,
  CancelOrderRequest as CancelOrderRequestOriginal,
  CancelOrderResponse as CancelOrderResponseOriginal,
  UpdateOrderStatusRequest as UpdateOrderStatusRequestOriginal,
  UpdateOrderStatusResponse as UpdateOrderStatusResponseOriginal,
  MarkAsFulfilledRequest as MarkAsFulfilledRequestOriginal,
  MarkAsFulfilledResponse as MarkAsFulfilledResponseOriginal,
  BulkMarkAsFulfilledRequest as BulkMarkAsFulfilledRequestOriginal,
  BulkMarkAsFulfilledResponse as BulkMarkAsFulfilledResponseOriginal,
  BulkMarkAsFulfilledByFilterRequest as BulkMarkAsFulfilledByFilterRequestOriginal,
  BulkMarkAsFulfilledByFilterResponse as BulkMarkAsFulfilledByFilterResponseOriginal,
  MarkAsUnfulfilledRequest as MarkAsUnfulfilledRequestOriginal,
  MarkAsUnfulfilledResponse as MarkAsUnfulfilledResponseOriginal,
  BulkMarkAsUnfulfilledRequest as BulkMarkAsUnfulfilledRequestOriginal,
  BulkMarkAsUnfulfilledResponse as BulkMarkAsUnfulfilledResponseOriginal,
  BulkMarkAsUnfulfilledByFilterRequest as BulkMarkAsUnfulfilledByFilterRequestOriginal,
  BulkMarkAsUnfulfilledByFilterResponse as BulkMarkAsUnfulfilledByFilterResponseOriginal,
  BulkSetBusinessLocationRequest as BulkSetBusinessLocationRequestOriginal,
  BulkSetBusinessLocationResponse as BulkSetBusinessLocationResponseOriginal,
  BulkSetBusinessLocationResult as BulkSetBusinessLocationResultOriginal,
  V1MarkOrderAsPaidRequest as V1MarkOrderAsPaidRequestOriginal,
  V1MarkOrderAsPaidResponse as V1MarkOrderAsPaidResponseOriginal,
  V1BulkMarkOrdersAsPaidRequest as V1BulkMarkOrdersAsPaidRequestOriginal,
  V1BulkMarkOrdersAsPaidResponse as V1BulkMarkOrdersAsPaidResponseOriginal,
  V1CreatePaymentGatewayOrderRequest as V1CreatePaymentGatewayOrderRequestOriginal,
  V1CreatePaymentGatewayOrderResponse as V1CreatePaymentGatewayOrderResponseOriginal,
  GetShipmentsRequest as GetShipmentsRequestOriginal,
  GetShipmentsResponse as GetShipmentsResponseOriginal,
  AggregateOrdersRequest as AggregateOrdersRequestOriginal,
  AggregateOrdersResponse as AggregateOrdersResponseOriginal,
  DecrementItemsQuantityRequest as DecrementItemsQuantityRequestOriginal,
  DecrementData as DecrementDataOriginal,
  DecrementItemsQuantityResponse as DecrementItemsQuantityResponseOriginal,
  BulkUpdateOrderTagsRequest as BulkUpdateOrderTagsRequestOriginal,
  TagsTags as TagsTagsOriginal,
  TagsTagList as TagsTagListOriginal,
  BulkUpdateOrderTagsResponse as BulkUpdateOrderTagsResponseOriginal,
  BulkUpdateOrderTagsResult as BulkUpdateOrderTagsResultOriginal,
  SendOrderUpdatedDomainEventRequest as SendOrderUpdatedDomainEventRequestOriginal,
  SendOrderUpdatedDomainEventResponse as SendOrderUpdatedDomainEventResponseOriginal,
  Task as TaskOriginal,
  TaskKey as TaskKeyOriginal,
  TaskAction as TaskActionOriginal,
  TaskActionActionOneOf as TaskActionActionOneOfOriginal,
  Complete as CompleteOriginal,
  Cancel as CancelOriginal,
  Reschedule as RescheduleOriginal,
  InvoiceSentEvent as InvoiceSentEventOriginal,
  IdAndVersion as IdAndVersionOriginal,
  InvoiceFields as InvoiceFieldsOriginal,
  Customer as CustomerOriginal,
  Email as EmailOriginal,
  QuotesAddress as QuotesAddressOriginal,
  AddressDescription as AddressDescriptionOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  Phone as PhoneOriginal,
  Company as CompanyOriginal,
  CommonAddress as CommonAddressOriginal,
  CommonAddressStreetOneOf as CommonAddressStreetOneOfOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  StandardDetails as StandardDetailsOriginal,
  InvoiceDates as InvoiceDatesOriginal,
  LineItems as LineItemsOriginal,
  LineItem as LineItemOriginal,
  BigDecimalWrapper as BigDecimalWrapperOriginal,
  LineItemTax as LineItemTaxOriginal,
  Source as SourceOriginal,
  SourceType as SourceTypeOriginal,
  SourceTypeWithLiterals as SourceTypeWithLiteralsOriginal,
  LineItemMetaData as LineItemMetaDataOriginal,
  Locale as LocaleOriginal,
  TotalPrice as TotalPriceOriginal,
  ItemizedFee as ItemizedFeeOriginal,
  Discount as DiscountOriginal,
  DiscountOneDiscountTypeOneOf as DiscountOneDiscountTypeOneOfOriginal,
  CalculatedTaxes as CalculatedTaxesOriginal,
  CalculatedTax as CalculatedTaxOriginal,
  Payments as PaymentsOriginal,
  InvoicesPayment as InvoicesPaymentOriginal,
  MetaData as MetaDataOriginal,
  InvoiceDynamicPriceTotals as InvoiceDynamicPriceTotalsOriginal,
  CustomFieldValue as CustomFieldValueOriginal,
  CustomFieldGroup as CustomFieldGroupOriginal,
  CustomFieldGroupWithLiterals as CustomFieldGroupWithLiteralsOriginal,
  Value as ValueOriginal,
  ValueType as ValueTypeOriginal,
  ValueTypeWithLiterals as ValueTypeWithLiteralsOriginal,
  Deposit as DepositOriginal,
  DepositType as DepositTypeOriginal,
  DepositTypeWithLiterals as DepositTypeWithLiteralsOriginal,
  InvoiceStatus as InvoiceStatusOriginal,
  InvoiceStatusWithLiterals as InvoiceStatusWithLiteralsOriginal,
  PreparePaymentCollectionApplicationErrors as PreparePaymentCollectionApplicationErrorsOriginal,
  RecordManuallyCollectedPaymentApplicationErrors as RecordManuallyCollectedPaymentApplicationErrorsOriginal,
  PaymentCollectionMarkOrderAsPaidApplicationErrors as PaymentCollectionMarkOrderAsPaidApplicationErrorsOriginal,
  PaymentCollectionCreatePaymentGatewayOrderApplicationErrors as PaymentCollectionCreatePaymentGatewayOrderApplicationErrorsOriginal,
  TriggerRefundApplicationErrors as TriggerRefundApplicationErrorsOriginal,
  VoidAuthorizedPaymentsApplicationErrors as VoidAuthorizedPaymentsApplicationErrorsOriginal,
  CaptureAuthorizedPaymentsApplicationErrors as CaptureAuthorizedPaymentsApplicationErrorsOriginal,
  GetOrderApplicationErrors as GetOrderApplicationErrorsOriginal,
  CreateOrderApplicationErrors as CreateOrderApplicationErrorsOriginal,
  UpdateOrderApplicationErrors as UpdateOrderApplicationErrorsOriginal,
  CancelOrderApplicationErrors as CancelOrderApplicationErrorsOriginal,
  UpdateOrderStatusApplicationErrors as UpdateOrderStatusApplicationErrorsOriginal,
} from './ecom-v1-order-orders.types.js';
